import { Nullable } from 'utils/types';
import { Club, Network } from '../api/types';
import { Firm } from 'screens/BrokerPortal/screens/Registration/api';
import { Form as PersonalDetailsForm } from 'screens/BrokerPortal/screens/Registration/components/PersonalDetailsStep/types';
import { Form as RegisterFirmForm } from 'screens/BrokerPortal/screens/Registration/components/RegisterFirmStep/types';
import { Form as DueDiligenceForm } from 'screens/BrokerPortal/screens/Registration/components/DueDiligenceStep/types';
import { Step } from 'screens/BrokerPortal/screens/Registration/steps';

export enum ACTION_TYPES {
  SET_SEARCH_FIRMS_FORM = 'SET_SEARCH_FIRMS_FORM',
  SET_SEARCH_FIRMS_FIRMS_ITEMS = 'SET_SEARCH_FIRMS_FIRMS_ITEMS',
  SET_SEARCH_FIRMS_FIRMS_ITEMS_LOADING = 'SET_SEARCH_FIRMS_FIRMS_ITEMS_LOADING',
  SET_DUE_DILIGENCE_FORM = 'SET_DUE_DILIGENCE_FORM',
  SET_REGISTER_FIRM_FORM = 'SET_REGISTER_FIRM_FORM',
  SET_PERSONAL_DETAILS_FORM = 'SET_PERSONAL_DETAILS_FORM',
  CLEAR_REGISTRATION = 'CLEAR_REGISTRATION',
  SET_NETWORK_ITEMS = 'SET_NETWORK_ITEMS',
  SET_CLUB_ITEMS = 'SET_CLUB_ITEMS',
  SET_NETWORK_ITEMS_LOADING = 'SET_NETWORK_ITEMS_LOADING',
  SET_CLUB_ITEMS_LOADING = 'SET_CLUB_ITEMS_LOADING',
  SET_ADD_ADDRESS_MANUALLY = 'SET_ADD_ADDRESS_MANUALLY',
  SET_CONTEXT_FIRM = 'SET_CONTEXT_FIRM',
  SET_REGISTER_LOADING = 'SET_REGISTER_LOADING',
  SET_CURRENT_STEP = 'SET_CURRENT_STEP',
}

export type Context = {
  firm: Firm | null;
};

export type State = {
  currentStep: Step | undefined;
  context: Context;
  searchFirms: {
    form: {
      firmId: Nullable<number>;
    };
    firms: {
      loading: boolean;
      items: Firm[];
    };
  };
  registerFirm: RegisterFirmState;
  dueDiligence: DueDiligenceStep;
  personalDetails: PersonalDetailsState;
};

export type RegisterFirmState = {
  networks: {
    loading: Nullable<boolean>;
    items: Network[];
  };
  clubs: {
    loading: Nullable<boolean>;
    items: Club[];
  };
  form: RegisterFirmForm;

  addAddressManually: boolean;
};

export type DueDiligenceStep = {
  form: DueDiligenceForm;
};

type PersonalDetailsState = {
  form: PersonalDetailsForm;
  registerLoading: boolean;
};
